/**
 * Pure URL builders for the customer API. Lifted from
 * `apps/customer-web/src/lib/api-base.ts` so customer-mobile can reuse
 * them without re-implementing path conventions.
 *
 * The base URL is passed in as a string so each app can resolve it from
 * its own env layer (Vite for web, Expo for mobile). When `base === ""`
 * the URL is same-origin (`/api/v1/...`); web uses Vite's dev proxy in
 * that mode.
 */
export function normalizeApiOrigin(raw) {
    let t = raw.trim().replace(/\/+$/, "");
    if (t === "")
        return "";
    t = t.replace(/\/api\/v1$/i, "").replace(/\/api$/i, "").replace(/\/+$/, "");
    return t;
}
export function dispensaryMenuUrl(base, slug) {
    const path = `/api/v1/dispensaries/${encodeURIComponent(slug)}/menu`;
    return base ? `${base}${path}` : path;
}
/**
 * `GET /api/v1/dispensaries/:slug/storefront-banner` — unauthenticated custom
 * banner image (migration 050). `version` is the menu payload's
 * `storefrontBannerUpdatedAt`, appended as a cache-buster so a re-upload shows
 * without waiting out the endpoint's Cache-Control.
 */
export function dispensaryStorefrontBannerUrl(base, slug, version) {
    const q = new URLSearchParams({ v: version });
    const path = `/api/v1/dispensaries/${encodeURIComponent(slug)}/storefront-banner?${q.toString()}`;
    return base ? `${base}${path}` : path;
}
/** `GET /api/v1/dispensaries/public-catalog` — active shops with a public slug (marketplace home). */
export function publicDispensaryCatalogUrl(base) {
    const path = "/api/v1/dispensaries/public-catalog";
    return base ? `${base}${path}` : path;
}
/** `GET /api/v1/compliance/delivery-zip?zip=` — unauthenticated (DEV-019). */
export function complianceDeliveryZipUrl(base, rawZip) {
    const q = new URLSearchParams({ zip: rawZip });
    const path = `/api/v1/compliance/delivery-zip?${q.toString()}`;
    return base ? `${base}${path}` : path;
}
/** `POST /api/v1/compliance/delivery-address` — unauthenticated private-residence gate (DEV-072). */
export function complianceDeliveryAddressUrl(base) {
    const path = "/api/v1/compliance/delivery-address";
    return base ? `${base}${path}` : path;
}
//# sourceMappingURL=url-builders.js.map